/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Großes Produktbild anzeigen
 *
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as portfolioActions from '../../../store/actions/portfolioActions';
import * as fileActions from "../../../store/actions/fileActions";
import * as appActions from "../../../store/actions/appActions";
import * as utils from "../../../basics/utils";
import BreadCrumpShort from "../../partials/BreadCrumpShort";
import { IconPortfolio } from "../../partials/Icons";
import UploadArea from "../../partials/UploadArea";
import { FabIconDelete } from "../../partials/Icons";
import { ImageLoader } from "../../partials/ImageLoader";


class ProductMain extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { unitHeight, toolbarHeight, path, appModus, orientation } = this.props.app;
        const { currentProduct } = this.props.portfolio;

        if (currentProduct === null) return null;

        const dialog = utils.getDialogByPath(path);

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        // ###############################################################
        // renderImage / Navigation
        // ---------------------------------------------------------------
        // Hier wird das große Produktbild angezeigt 
        // ###############################################################
        const renderImage = () => {
            if (!this.props.node) return null;

            const onClick = () => {
                this.props.setPath(dialog.portfolio + "/" + dialog.groups)
            }

            if (appModus === 'Admin') {
                const nodeImage = utils.getProductImage(this.props.node, path, 'main');

                const onDelete = () => {

                    const onDeleteSuccess = () => {
                        this.props.scanPortfolio(dialog.portfolio);
                    }

                    const onDeleteError = (error) => {
                        console.log('onDelete() error:', error);
                    }

                    this.props.deleteFile('product', path, nodeImage.fileName, onDeleteSuccess, onDeleteError);
                }

                const style = {
                    backgroundColor: 'rgba(255,255,255,.3)',
                    ...utils.getStyleBackgroundURL(nodeImage.url)
                };

                if (nodeImage.fileName === '') {
                    return (<UploadArea uploadArea='image' uploadType='product' uploadPath={path} uploadPost='main' />)
                } else {
                    return (
                        <div className="relative w-full h-full z-25" style={style} onClick={onClick}>
                            {FabIconDelete("Bild entfernen", onDelete, orientation === 'portrait' ? toolbarHeight : 0)}
                        </div>
                    )
                }

            } else {

                const fileObj = utils.getFileInNode(this.props.node, 'main');
                if (!fileObj) return null;

                const className = (orientation === 'portrait') ? "absolute mt-2 w-full h-full z-25" : "relative w-full h-full z-25";

                return (
                    <div className={className} onClick={onClick}>
                        <ImageLoader path={fileObj.path} name={fileObj.name} height={'100%'} cover={'cover'} />
                    </div>
                )
            }
        }

        // ###############################################################
        // renderIconPortfolio / Navigation
        // ---------------------------------------------------------------
        // PortfilioIcon anzeigen
        //           +----+ 
        //           | LT | 
        //           +----+ 
        // ###############################################################
        const renderIconPortfolio = () => {
            const portfolio = utils.getPortfolio(dialog.portfolio);

            return (
                <div className="absolute bottom-0 right-0 p-2">
                    {IconPortfolio(portfolio, unitHeight * 3, () => this.props.setPath(dialog.portfolio))}
                </div>
            )
        }

        // ###############################################################
        // renderTitle / Navigation
        // ---------------------------------------------------------------
        // Title anzeigen
        //
        //     Fahrerstand-Niederhubwagen
        //     T16P | T20P
        // ###############################################################

        const renderTitle = () => {

            if (!this.props.node) return null;

            let meta = { subTitle: '' };
            const metaNode = this.props.node.filter(d => d.name === 'meta.json')
            if (metaNode.length > 0) {
                meta = metaNode[0].meta;
            }

            const onEditTitle = () => {
                if (appModus === 'Admin') {
                    this.props.setModalDialog('ProductModal', 'update');
                }
            }

            const styleTitle = utils.getStyleHeight(unitHeight, 1.0, .6, .6)
            const styleSubTitle = utils.getStyleHeight(unitHeight, .4, .3, .3)

            const style = { backgroundColor: 'rgba(255,255,255,.3)' };

            return (
                <div className="absolute bottom-0 w-full flex font-bold" >
                    <div className="w-5/6 flex p-2">
                        <table className="table-auto" style={style} onClick={onEditTitle}>
                            <tbody>
                                <tr><td className="pl-2 pr-4" style={styleSubTitle}>{meta['subTitle'] && meta.subTitle.toUpperCase()}</td></tr>
                                <tr><td className="pl-2 pr-4" style={styleTitle}>{currentProduct.name.replace(/_/g, ' ')}</td></tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="w-1/6 flex h-full bg-red-400">
                        {renderIconPortfolio()}
                    </div>
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================
        return (
            <div className="relative w-full h-full flex flex-col pt-2">
                {renderImage()}
                {renderTitle()}
                {orientation === 'portrait' && <BreadCrumpShort />}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        file: state.file,
        portfolio: state.portfolio
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, fileActions, portfolioActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductMain);
